import React from 'react';
import { V2LessonControl } from './LessonControl';

export const V2LessonOps: React.FC = () => {
  return <V2LessonControl surface="ops" />;
};

